export default __webpack_public_path__ + "static/media/profile_pic.c5c41fbe.jpg";